class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('.cart-notification__close, .soe-cart-notification__continue').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.setAttribute('aria-hidden', 'false');
    this.notification.classList.add('animate');
    requestAnimationFrame(() => {
      this.notification.classList.add('active');
      requestAnimationFrame(() => {
        if (this.notification.classList.contains('active')) trapFocus(this.notification);
      });
    });

    document.body.removeEventListener('click', this.onBodyClick);
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.notification.setAttribute('aria-hidden', 'true');
    document.body.removeEventListener('click', this.onBodyClick);

    const focusTarget = this.activeElement?.isConnected ? this.activeElement : null;
    this.activeElement = null;
    removeTrapFocus(focusTarget);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const sectionHtml = parsedState.sections?.[section.id];
      if (!target || !sectionHtml) return;

      const updatedContent = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (updatedContent !== null) target.innerHTML = updatedContent;
    });

    const quantity = this.querySelector('[data-cart-notification-quantity]');
    if (quantity && Number.isFinite(Number(parsedState.quantity))) quantity.textContent = parsedState.quantity;

    this.notification.scrollTop = 0;
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const source = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return source ? source.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
